(function() {
  'use strict';

  function initDescriptionStyling(productId) {
    const description = document.querySelector(`[data-product-description="${productId}"]`);
    if (!description) return;

    const ulElements = description.querySelectorAll('ul');
    ulElements.forEach(ul => {
      ul.style.display = 'none';
    });

    const liElements = description.querySelectorAll('ul li');
    liElements.forEach((li, index, arr) => {
      li.style.fontWeight = 'bold';
      li.style.color = '#000000';
      li.style.paddingBottom = '10px';
      li.style.paddingTop = '10px';
      li.style.borderBottom = index === arr.length - 1 ? 'none' : '1px dashed #e4e9f1';
    });

    const strongElements = description.querySelectorAll('ul li strong:first-child');
    strongElements.forEach(strong => {
      strong.style.color = '#6f7075';
      strong.style.fontWeight = 'normal';
      strong.style.width = '96px';
      strong.style.display = 'inline-block';
    });
  }

  function initAllProductDescriptions() {
    const descriptions = document.querySelectorAll('[data-product-description]');
    descriptions.forEach(desc => {
      const productId = desc.getAttribute('data-product-description');
      if (productId) {
        initDescriptionStyling(productId);
      }
    });
  }

  function handleMoreDetailsClick(e) {
    const btn = e.target.closest('[data-product-more-details-btn]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const productId = btn.getAttribute('data-product-more-details-btn');
    const container = document.querySelector(`[data-product-description-container="${productId}"]`);
    const description = document.querySelector(`[data-product-description="${productId}"]`);
    const lessBtn = document.querySelector(`[data-product-less-details-btn="${productId}"]`);

    if (container) {
      container.classList.remove('max-h-[61px]');
      container.style.maxHeight = 'none';
    }

    if (description) {
      const ulElements = description.querySelectorAll('ul');
      ulElements.forEach(ul => {
        ul.style.display = '';
      });
    }

    if (lessBtn) {
      lessBtn.style.display = '';
    }

    if (btn.parentElement) {
      btn.parentElement.style.display = 'none';
    }
  }

  function handleLessDetailsClick(e) {
    const btn = e.target.closest('[data-product-less-details-btn]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const productId = btn.getAttribute('data-product-less-details-btn');
    const container = document.querySelector(`[data-product-description-container="${productId}"]`);
    const description = document.querySelector(`[data-product-description="${productId}"]`);
    const moreBtn = document.querySelector(`[data-product-more-details-btn="${productId}"]`);

    if (container) {
      container.classList.add('max-h-[61px]');
      container.style.maxHeight = '61px';
    }

    if (description) {
      const ulElements = description.querySelectorAll('ul');
      ulElements.forEach(ul => {
        ul.style.display = 'none';
      });
    }

    btn.style.display = 'none';

    if (moreBtn && moreBtn.parentElement) {
      moreBtn.parentElement.style.display = '';
    }
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-product-more-details-btn]')) {
      handleMoreDetailsClick(e);
      return;
    }

    if (e.target.closest('[data-product-less-details-btn]')) {
      handleLessDetailsClick(e);
      return;
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllProductDescriptions);
  } else {
    initAllProductDescriptions();
  }

  window.ProductDescriptionDetails = {
    init: initAllProductDescriptions,
    initProduct: initDescriptionStyling
  };

  document.addEventListener('shopify:section:load', initAllProductDescriptions);
  const observer = new MutationObserver(function(mutations) {
    let shouldInit = false;
    
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.querySelector && node.querySelector('[data-product-description]')) {
              shouldInit = true;
              break;
            }
          }
        }
      }
      if (shouldInit) break;
    }
    
    if (shouldInit) {
      clearTimeout(window._productDescriptionInitTimeout);
      window._productDescriptionInitTimeout = setTimeout(initAllProductDescriptions, 100);
    }
  });

  const targetNode = document.querySelector('main') || document.body;
  observer.observe(targetNode, {
    childList: true,
    subtree: true
  });
})();
